module.exports = __webpack_public_path__ + "slider-2-mobile.jpg?3083641e2d57b28cf9f0883ff564d348";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/slider-2-mobile.jpg
// module id = 306
// module chunks = 0